const sizeStyles = {
  inputStyles: {
    sm: {},
    md: {},
    lg: {
      fontSize: "16px",
      lineHeight: "20",
      fontWeight: 500
    }
  },
  inputFilledStyles: {
    sm: { paddingRight: 30 },
    md: { paddingRight: 30 },
    lg: { paddingRight: 46 }
  },
  countryIconStyles: {
    sm: {},
    md: {},
    lg: {}
  }
}, inputStyles = {
  labelCompact: {
    flexDirection: "row",
    gap: 10,
    alignItems: "end",
    minWidth: 100,
    height: 20
  }
}, fieldSizeMap = {
  sm: 30,
  md: 42,
  lg: 60
}, sizeStylesControl = {
  labelCompact: {
    sm: {
      paddingBottom: 0
    },
    md: {
      paddingBottom: 3
    },
    lg: {
      paddingBottom: 4
    }
  },
  fullLabel: {
    sm: {
      height: fieldSizeMap.sm
    },
    md: {
      height: fieldSizeMap.md
    },
    lg: {
      height: fieldSizeMap.lg
    }
  },
  labelContainer: {
    sm: {
      gap: 6
    },
    md: {
      gap: 12
    },
    lg: {
      gap: 12
    }
  }
}, ICON_COLOR_VAR_NAME = "--icon-fill", heightsSizeMap = {
  xs: 24,
  sm: 30,
  md: 36,
  lg: 42,
  /** @deprecated 'xl' is deprecated */
  xl: 64
};
export {
  ICON_COLOR_VAR_NAME,
  fieldSizeMap,
  heightsSizeMap,
  inputStyles,
  sizeStyles,
  sizeStylesControl
};
//# sourceMappingURL=Common.js.map
